import { render, staticRenderFns } from "./thankyou.vue?vue&type=template&id=5dc7737c"
import script from "./thankyou.vue?vue&type=script&lang=js"
export * from "./thankyou.vue?vue&type=script&lang=js"
import style0 from "./thankyou.vue?vue&type=style&index=0&id=5dc7737c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports